import {Box} from "@mui/material";
import React from "react";
import {Route, Routes} from "react-router-dom";
import {MinimalAppBar} from "../shell/MinimalAppBar";
import {TenantCreate} from "./TenantCreate";
import {TenantSelection} from "./TenantSelection";

export function Tenants() {
	return (
		<Box sx={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
			<MinimalAppBar />
			<Box sx={{flex: 1}}>
				<Routes>
					<Route path="new" element={<TenantCreate />} />
					<Route index element={<TenantSelection />} />
				</Routes>
			</Box>
		</Box>
	);
}
